import { render, staticRenderFns } from "./HoldRequestForm.vue?vue&type=template&id=fd54d6a0"
import script from "./HoldRequestForm.vue?vue&type=script&lang=js"
export * from "./HoldRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports